<template>
		<div class="address-card">
			<div class="section">
				<div v-if="addressInfo.length > 0" class="section-title">
					<div class="title-bar"></div>
					<h3>公司地址</h3>
				</div>
				<div class="section-content flex-layout">
					<div v-for="(item, index) in addressInfo" :key="index" class="info-item">
						<div class="icon-container">
							<div class="icon address"></div>
						</div>
						<div class="info-text">{{ item.text }}</div>
					</div>
				</div>
			</div>
		</div>
	</template>

	<script setup>
	const props = defineProps({
		addressInfo: {
			type: Array,
			required: true
		}
	})
	</script>

	<style scoped>
	.address-card {
		background-color: white;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		padding: 20px;
		transition: box-shadow 0.3s ease;
	}

	.section-title {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
	}

	.title-bar {
		width: 4px;
		height: 16px;
		background-color: #0055A2;
		margin-right: 10px;
	}

	.section-title h3 {
		color: #333;
		font-size: 16px;
		font-weight: 600;
		margin: 0;
	}

	.flex-layout {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.flex-layout .info-item {
		display: flex;
		align-items: flex-start;
		flex: 1 0 auto;
		min-width: 200px;
	}

	.info-item {
		display: flex;
		align-items: flex-start;
	}

	.icon-container {
		margin-right: 16px;
		margin-top: 2px;
		display: flex;
		align-items: flex-start;
	}

	.icon {
		width: 16px;
		height: 16px;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: center;
	}

	.icon.address {
        background-image: url("@/assets/address.png");
        width: 13px;
        height: 13px;
	}

	.info-text {
		color: #666;
		font-size: 14px;
		line-height: 1.5;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.address-card {
			padding: 15px;
		}

		.flex-layout .info-item {
			min-width: 150px;
		}
	}

	@media (max-width: 480px) {
		.address-card {
			padding: 12px;
		}

		.flex-layout {
			flex-direction: column;
			gap: 12px;
		}

		.flex-layout .info-item {
			min-width: 100%;
		}

		.section-title h3 {
			font-size: 15px;
		}

		.info-text {
			font-size: 13px;
		}
	}
	</style>